<template>
  <div>
    <!-- 配货单待装箱 -->
    <baseBreadcrumb
      :page="$t('message.orderToBePacked')"
      :menu="$t('message.porder')"
    />

    <porderBaseTable :status="21" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>